type ActiveFlags = {
  [variation: string]: string;
  flagKey: string;
  variationA: 'A';
  variationB: 'B';
};

export const saleLabelPercentage: ActiveFlags = {
  flagKey: 'sale-label-percentage',
  variationA: 'A',
  variationB: 'B',
};
